<template>
	<div  id="div-nav" class="headContainer">
		<div class="roww  center_center" style="width: 100vw;">
			<img src="../../static/logo.jpg" style="width: 250px;height: 100px;" />
			<div style="width:30px;"></div>
			<div class="roww ">
				<div class="colonn " :class="{
					'topmenuviewtxt1':indexType==0,
					'topmenuviewtxt':indexType!=0,
				}" @click.stop="indexTypeClick(0)">
					<div>首页</div>
				</div>
				<div class="colonn  " :class="{
					'topmenuviewtxt':indexType!=1,
					'topmenuviewtxt1':indexType==1,
				}" @click.stop="indexTypeClick(1)">
					<div>关于我们</div>
				</div>
				<div class="colonn  " :class="{
					'topmenuviewtxt':indexType!=2,
					'topmenuviewtxt1':indexType==2,
				}" @click.stop="indexTypeClick(2)">
					<div>服务范围</div>
				</div>

				<div class="colonn  " :class="{
					'topmenuviewtxt':indexType!=3,
					'topmenuviewtxt1':indexType==3,
				}" @click.stop="indexTypeClick(3)">
					<div>案例展示</div>
				</div>


				<!-- <el-dropdown>
					<div class="colonn  " :class="{
					'topmenuviewtxt':indexType!=3,
					'topmenuviewtxt1':indexType==3,
				}" @click.stop="indexTypeClick(3)">
						<span class="el-dropdown-link" style="font-size: 17px;color: black;font-weight: 510;"
						:style="{
							color:indexType==3?'rgb(187, 27, 33)':'rgb(187, 27, 33)'
						}"
						>
							案例展示<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item style="color: red;"
							@click.stop="indexTypeClick(7)"
							>轮胎展</el-dropdown-item>
							<el-dropdown-item style="color: red;">粮油展</el-dropdown-item>
						</el-dropdown-menu>
					</div>
				</el-dropdown> -->



				<!-- <div class="colonn topmenuviewtxt">
					<div>新闻中心</div>
				</div> -->
				<div class="colonn  " :class="{
					'topmenuviewtxt':indexType!=5,
					'topmenuviewtxt1':indexType==5,
				}" @click.stop="indexTypeClick(5)">
					<div>咨询合作</div>
				</div>
				<div class="colonn  " :class="{
					'topmenuviewtxt':indexType!=6,
					'topmenuviewtxt1':indexType==6,
				}" @click.stop="indexTypeClick(6)">
					<div>联系我们</div>
				</div>
			</div>
		</div>
		<shouye v-if="indexType==0"></shouye>
		<about v-if="indexType==1"></about>
		<service v-if="indexType==2"></service>
		<zixunhezuo v-if="indexType==5"></zixunhezuo>
		<lianxiwomen v-if="indexType==6"></lianxiwomen>
		<anlizhanshi v-if="indexType==3"></anlizhanshi>
		<zhan_img v-if="indexType==7"></zhan_img>





		<div class="bottomview roww rowsa" style="height: auto;">
			<div class="colonn" style="color: white;">
				<div style="height: 30px;"></div>
				<div style="line-height: 50px;">联系我们：</div>
				<div style="font-size: 11px;">电话：0531-86160666</div>
				<div style="font-size: 11px;">邮箱：2979882323@qq.com </div>
				<div style="font-size: 11px;">地址：山东省济南市历下区泉城路26号世贸广场A座9楼</div>
			</div>
			<div class="colonn" style="color: white;">
				<div class="colonn">
					<div class="roww" style="margin:10px 0px;">
						<span style="color: red;">*</span>
						<div>姓名</div>
					</div>
					<div class="inputview roww">
						<!-- <input class="inputview" placeholder="请输入姓名" /> -->
						<el-input v-model="form.name" placeholder="请输入姓名"></el-input>
					</div>
				</div>
				<div class="colonn">
					<div class="roww" style="margin:10px 0px;">
						<span style="color: red;">*</span>
						<div>电话</div>
					</div>
					<div class="inputview roww">
						<el-input v-model="form.phone" placeholder="请输入电话"></el-input>
					</div>
				</div>

				<div class="colonn">
					<div class="roww" style="margin:10px 0px;">
						<span style="color: red;">*</span>
						<div>内容</div>
					</div>
					<div class="inputview roww">
						<el-input v-model="form.context" placeholder="请输入内容"></el-input>
					</div>
				</div>

				<!-- <div class="tijiab">提交</div> -->
				<div style="height: 20px;"></div>
				<el-button type="danger" @click="toSubmit">提交</el-button>
			</div>
		</div>
		
		<div class="roww center_center"
			style="background-color: rgb(77, 77, 77);height: 100px;width:100vw;font-size: 10px;">
			<div class="colonn center_center">
				<div> © 瑞尔会展 ( 山东 ) 有限公司 2019 All Rights Reserved.版权所有</div>
				<div>鲁ICP备20032105号-2</div>
			</div>
		</div>


		<lianxi></lianxi>
		
		
		<BackToTop></BackToTop>

	</div>
</template>

<script>
	import shouye from "../shouye/shouye.vue"
	import about from "../about/about.vue"
	import service from "../service/service.vue"
	import zixunhezuo from "../zixunhezuo/zixunhezuo.vue"
	import lianxiwomen from "../lianxiwomen/lianxiwomen.vue"
	import anlizhanshi from "../anlizhanshi/anlizhanshi.vue"
	import zhan_img from "../zhan_img/zhan_img.vue"
	import lianxi from "../lianxi/lianxi.vue"

		import BackToTop from '../BackToTop.vue'

	export default {
		name: 'ComponentName', // 组件的名称
		components: {
			shouye,
			about,
			service,
			zixunhezuo,
			lianxiwomen,
			anlizhanshi,
			zhan_img,
			lianxi,BackToTop
		},

		data() {
			return {
				// 组件的数据属性
				swiperOption: {
					pagination: '.swiper-pagination',
					autoplay: 4500,
					loop: true,
				},



				indexType: 0,
				form:{
					name:"",
					phone:"",
					context:''
				},
			}
		},

		props: {
			// 组件的属性
		},

		computed: {
			// 组件的计算属性
		},

		methods: {
			
			toSubmit(){
				if(this.form.name==""){
					this.tishiTo(0,"请输入姓名");
					return false;
				}
				if(this.form.phone==""){
					this.tishiTo(1,"请输入联系电话");
					return false;
				}
				if(this.form.context==""){
					this.tishiTo(2,"请输入内容");
					return false;
				}
				this.tishiTo(3,"提交成功");
			},
			tishiTo(type,conent){
				if(type==3){
					this.$notify({
					  title: '成功',
					  message: conent,
					  type: 'success'
					});
				}else{
					this.$notify({
					  title: '错误',
					  message: conent,
					  type: 'error'
					});
				}
				        
			},
			indexTypeClick(index) {
				this.indexType = index;
			},


			// 组件的方法
			onClick(i) {
				alert(i)
			}
		},

		mounted() {
			// 组件挂载后的操作
		},

		// 其他生命周期钩子函数和组件选项
	}
</script>

<style>
	@import url(home.css);
</style>